import { render } from "./SentComponent.vue?vue&type=template&id=c5399932&scoped=true"
import script from "./SentComponent.vue?vue&type=script&lang=js"
export * from "./SentComponent.vue?vue&type=script&lang=js"

import "./SentComponent.vue?vue&type=style&index=0&id=c5399932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5399932"]])

export default __exports__